import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  numberAttribute,
  viewChild
} from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'mng-inputfield-text',
  imports: [
    MatFormField,
    NgStyle,
    ExtendedModule,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatHint,
    MatError,
    CdkTextareaAutosize
  ],
  templateUrl: './input-field-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldTextComponent extends InputFieldBaseComponent {
  readonly rows = input(3, { transform: numberAttribute });
  readonly maxRows = input(10, { transform: numberAttribute });
  readonly showLengthHint = input(undefined, { transform: numberAttribute });
  readonly dialogInfoText = input<string>();
  readonly ngTextareaStyle = input<object>();
  readonly textAreaElementRef = viewChild<ElementRef<HTMLTextAreaElement>>('textarea');
  readonly noRowsSetting = input(false, { transform: booleanAttribute });

  onKeyEvent = (event: KeyboardEvent) => {
    super.onKeyEvent(event);
  };
}
